const angular = require('angular');
const { compact, each, replace, uniqBy } = require('lodash');

const key = { esc: 27 };
const newlineCharacter = '\n';

class SearchMultisearchController {
    constructor($state, $timeout, $window, moveFocus, settings, searchMultisearchService) {
        this.$state = $state;
        this.$timeout = $timeout;
        this.$window = $window;
        this.moveFocus = moveFocus;
        this.settings = settings;
        this.searchMultisearchService = searchMultisearchService;
    }

    $onInit() {
        this.multisearchText = '';
        this.searchLimitErrorMessage = '';
        this.showSearchLimitError = false;
        this.searchLimitErrorMessage = this.settings.search.searchItemLimitReached;
        this.maximumItemsToSearch = this.settings.search.maximumItemsToSearch;
    }

    getMultisearchList() {
        // Split each line by the new line character then remove duplicates, remove empty rows, trim
        return uniqBy(compact(each(this.multisearchText.trim().split(newlineCharacter), value => value.trim())));
    }

    toggleMultisearch() {
        if (this.isActive) {
            this.$timeout(() => {
                this.isActive = false;
                this.moveFocus('#headerSearch');
            });
        } else {
            this.searchMultisearchService.updateMultisearchItems().then((multisearchItems) => {
                if (multisearchItems && multisearchItems.length > 0) {
                    this.multisearchText = multisearchItems.join(newlineCharacter);
                }
            });
            this.$timeout(() => {
                this.isActive = true;
                this.moveFocus('#multisearch-textbox');
            });
        }
    }

    onPaste($event) {
        $event.preventDefault();
        let clipboardData = this.$window.clipboardData ? this.$window.clipboardData.getData('Text') : $event.originalEvent.clipboardData.getData('text/plain');

        if (clipboardData === undefined || !clipboardData.trim()) {
            return;
        }

        clipboardData = clipboardData.trim();
        // Convert a comma seperated list to newline seperated list (must not be already newline seperated)
        // Regex will replace all commas and also trim (\s*)
        if (clipboardData.indexOf(newlineCharacter) === -1) {
            clipboardData = replace(clipboardData, /\s*,\s*/g, newlineCharacter);
        }

        // Find out where the cursor is
        const cursorStart = $event.currentTarget.selectionStart;
        const cursorEnd = $event.currentTarget.selectionEnd;
        // Insert and replace selection (if there is any)
        this.multisearchText = this.multisearchText.substr(0, cursorStart) + clipboardData + this.multisearchText.substr(cursorEnd);

        // Move the cursor to the end of the pasted string
        const targetCursorPosition = cursorStart + clipboardData.length;
        this.$timeout(() => {
            $event.currentTarget.setSelectionRange(targetCursorPosition, targetCursorPosition);
            this.updateScroll($event.currentTarget, targetCursorPosition);
        });
    }

    updateScroll(textareaElement, cursorPosition) {
        const lineHeight = 41; // Line height is from search-multisearch.component.less
        const lineNumberOfCursor = this.getNumberofItems(each(this.multisearchText.substring(0, cursorPosition).trim().split(newlineCharacter)));
        const bottomOfContent = lineHeight * lineNumberOfCursor;
        const topOfContent = bottomOfContent - lineHeight > 0 ? bottomOfContent - lineHeight : 0;

        if (bottomOfContent > textareaElement.scrollTop) {
            textareaElement.scrollTop = topOfContent;
        }
    }

    onKeydown($event) {
        switch ($event.keyCode) {
            // Escape
            case key.esc:
                $event.stopPropagation();
                $event.preventDefault();
                this.toggleMultisearch();
                break;
            // Others
            default:
                break;
        }
    }

    getNumberofItems(items = this.getMultisearchList()) {
        return items.length;
    }

    isOverMaximumLimit(listLength = this.getNumberofItems()) {
        return listLength > this.maximumItemsToSearch;
    }

    executeMultisearch() {
        const multisearchList = this.getMultisearchList();

        // Validation check
        if (this.isOverMaximumLimit(multisearchList.length)) {
            return;
        }

        this.searchMultisearchService.updateMultisearchItems(multisearchList.join(',')).then((multisearchItems) => {
            const firstItem = multisearchItems[0];
            if (!firstItem || firstItem.length < 1) {
                return;
            }

            this.$state.go('shop.search', { searchTerm: firstItem, multisearchItems: multisearchItems.join(',') }, { inherit: false, reload: true });

            if (angular.isFunction(this.onMultisearch)) {
                this.onMultisearch();
            }
        });
    }
}

const searchMultisearchComponentDefinition = {
    bindings: {
        isActive: '=?',
        searchTerm: '=?',
        onMultisearch: '&?',
    },
    controller: ['$state', '$timeout', '$window', 'MoveFocus', 'Settings', 'SearchMultisearchService', SearchMultisearchController],
    template: require('./search-multisearch.component.html').trim(),
};

module.exports = {
    SearchMultisearchController,
    searchMultisearchComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/search/search-multisearch.component.js